module.exports = __webpack_public_path__ + "static/media/front.9abe8627.jpg";